module.exports = __webpack_public_path__ + "static/img/emhyr_relentless.9a275e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/emhyr_relentless.png
// module id = XKH0
// module chunks = 0